"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCustomWorkspaceSettings = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var decoratedBackend_1 = require("../decoratedBackend");
var workspaceSettings_1 = require("../decoratedBackend/workspaceSettings");
var WithModifiedWorkspaceSettingsService = /** @class */ (function (_super) {
    tslib_1.__extends(WithModifiedWorkspaceSettingsService, _super);
    function WithModifiedWorkspaceSettingsService(decorated, settingsWrapper, currentUserSettingsWrapper, commonSettingsSetter) {
        var _this = _super.call(this, decorated) || this;
        _this.settingsWrapper = settingsWrapper;
        _this.currentUserSettingsWrapper = currentUserSettingsWrapper;
        _this.commonSettingsSetter = commonSettingsSetter;
        return _this;
    }
    WithModifiedWorkspaceSettingsService.prototype.getSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var settings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.decorated.getSettings()];
                    case 1:
                        settings = _a.sent();
                        return [2 /*return*/, this.settingsWrapper(tslib_1.__assign(tslib_1.__assign({}, settings), this.commonSettingsSetter(settings)))];
                }
            });
        });
    };
    WithModifiedWorkspaceSettingsService.prototype.getSettingsForCurrentUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentUserSettings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.decorated.getSettingsForCurrentUser()];
                    case 1:
                        currentUserSettings = _a.sent();
                        return [2 /*return*/, this.currentUserSettingsWrapper(tslib_1.__assign(tslib_1.__assign({}, currentUserSettings), this.commonSettingsSetter(currentUserSettings)))];
                }
            });
        });
    };
    return WithModifiedWorkspaceSettingsService;
}(workspaceSettings_1.DecoratedWorkspaceSettingsService));
function customWorkspaceSettings(config) {
    var emptySettingsSetter = function () { return ({}); };
    return function (original) {
        return new WithModifiedWorkspaceSettingsService(original, config.settingsWrapper || identity_1.default, config.currentUserSettingsWrapper || identity_1.default, config.commonSettingsWrapper || emptySettingsSetter);
    };
}
/**
 * Adjusts workspace configs and current user configs from the real backend.
 *
 * @remarks see {@link WorkspaceSettingsConfiguration} properties for more information.
 * @param realBackend - real backend to decorate with custom workspace settings
 * @param config - workspace configs configuration
 * @beta
 */
function withCustomWorkspaceSettings(realBackend, config) {
    var workspaceSettings = customWorkspaceSettings(config);
    return decoratedBackend_1.decoratedBackend(realBackend, { workspaceSettings: workspaceSettings });
}
exports.withCustomWorkspaceSettings = withCustomWorkspaceSettings;
//# sourceMappingURL=index.js.map